// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"cad60cf7","239":"2831e374","397":"805ccebb","488":"18c11d5c"}[chunkId] + ".chunk.js";
};